import React, { useState, useEffect } from "react";
import {
  FaTachometerAlt,
  FaTasks,
  FaCog,
  FaSignOutAlt,
  FaBell,
  FaUserCircle,
  FaCalendarAlt,
} from "react-icons/fa";
import { PiBookOpenTextLight } from "react-icons/pi";
import { GrSchedules } from "react-icons/gr";
import { MdOutlineTrackChanges } from "react-icons/md";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import Calendar from "react-calendar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "react-calendar/dist/Calendar.css";
import ProfileModal from './StudentProfileModal';
import Tooltip from "@mui/material/Tooltip";
import {
  Box, Typography, Avatar, Chip, CircularProgress,
  IconButton, Tooltip as MuiTooltip, Popover, Divider,
} from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import CloseIcon from "@mui/icons-material/Close";

function StudentsSidebar({ content }) {
  const [showCalendar, setShowCalendar] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [messages, setMessages] = useState([]);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [activeItem, setActiveItem] = useState("dashboard");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
const [hasMoreNotifications, setHasMoreNotifications] = useState(false);
const hasMoreRef = React.useRef(false);
const [notifPageNo, setNotifPageNo] = useState(1);
const notifPageNoRef = React.useRef(1);
const [loadingMoreNotifs, setLoadingMoreNotifs] = useState(false);
const [markingAll, setMarkingAll] = useState(false);
const [showNotifDropdown, setShowNotifDropdown] = useState(false);
const [notifAnchor, setNotifAnchor] = useState(null);
const notifListRef = React.useRef(null);
const intervalRef = React.useRef(null);
  let navigate = useNavigate();
  let location = useLocation();

  const handleProfileClick = () => {
    setShowProfileModal(true);
  };

  const handleCloseProfileModal = () => {
    setShowProfileModal(false);
  };

  // Icon mapping based on form names
  const getIconForForm = (formName) => {
    const formNameLower = formName.toLowerCase();
    
    if (formNameLower.includes('assignment') || formNameLower.includes('task')) {
      return <FaTasks />;
    }
    if (formNameLower.includes('study') || formNameLower.includes('material') || formNameLower.includes('subject')) {
      return <PiBookOpenTextLight />;
    }
    if (formNameLower.includes('time') || formNameLower.includes('schedule') || formNameLower.includes('timetable')) {
      return <GrSchedules />;
    }
    if (formNameLower.includes('topic') || formNameLower.includes('progress') || formNameLower.includes('tracker')) {
      return <MdOutlineTrackChanges />;
    }
    if (formNameLower.includes('setting') || formNameLower.includes('config')) {
      return <FaCog />;
    }
    
    // Default icon
    return <AiOutlineQuestionCircle />;
  };

  // Map form names to route identifiers
  const getRouteId = (formName) => {
    const routeMap = {
      "Assignment": "assignment",
      "Study Material": "study material",
      "Time Table": "time table",
      "Topic Progress": "topic progress",
      "Settings": "setting",
    };
    
    return routeMap[formName] || formName.toLowerCase();
  };

  // Fetch menu items from API
  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const token = sessionStorage.getItem("token");

        const response = await fetch(`${apiUrl}/ExclusivePermission/GetSearchForm`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch menu items: ${response.status}`);
        }

        const data = await response.json();
        
        // Filter only Student Portal items with permission
        const studentPortalItems = data.filter(
          item => item.moduleName === "Student Portal" && item.isPermission === 1
        );

        // Sort by formId to maintain order
        const sortedItems = studentPortalItems.sort((a, b) => 
          parseInt(a.formId) - parseInt(b.formId)
        );

        setMenuItems(sortedItems);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching menu items:", error);
        setLoading(false);
      }
    };

    fetchMenuItems();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Set activeItem based on current path
    const path = location.pathname;
    if (path.includes("/studentDashboard")) {
      setActiveItem("dashboard");
    } else if (path.includes("/assignmentList")) {
      setActiveItem("assignment");
    } else if (path.includes("/subjects")) {
      setActiveItem("study material");
    } else if (path.includes("/time-table")) {
      setActiveItem("time table");
    } else if (path.includes("/student-topic-progress")) {
      setActiveItem("topic progress");
    } else if (path.includes("/comingsoon")) {
      setActiveItem("setting");
    }
  }, [location.pathname]);

  const handleCalendarToggle = () => {
    setShowCalendar(!showCalendar);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/");
  };

  const studentName = sessionStorage.getItem("clientName");
  const OrgName = sessionStorage.getItem("organizationName").replace(/['"]+/g, "");

 const apiUrl = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");

  const fetchNotifications = async (pageNo = 1, append = false) => {
    try {
      const response = await fetch(
        `${apiUrl}/NewNotification/GetMyNotifications?PageNo=${pageNo}&PageSize=20`,
        { headers: { "Content-Type": "application/json", Authorization: token } }
      );
      const data = await response.json();
      const items = Array.isArray(data.data) ? data.data : [];
      setMessages(prev => append ? [...prev, ...items] : items);
      setHasMoreNotifications(items.length === 20);
      hasMoreRef.current = items.length === 20;
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const fetchUnreadCount = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/NewNotification/GetUnreadCount`,
        { headers: { "Content-Type": "application/json", Authorization: token } }
      );
      const data = await response.json();
      setUnreadMessages(typeof data.unreadCount === 'number' ? data.unreadCount : 0);
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    intervalRef.current = setInterval(fetchUnreadCount, 30000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const markAsRead = async (recipientId) => {
    setMessages(prev => prev.map(n => n.recipientId === recipientId ? { ...n, isRead: true } : n));
    setUnreadMessages(prev => Math.max(0, prev - 1));
    try {
      await fetch(`${apiUrl}/NewNotification/MarkAsRead`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({ recipientId }),
      });
    } catch (error) {
      setMessages(prev => prev.map(n => n.recipientId === recipientId ? { ...n, isRead: false } : n));
      setUnreadMessages(prev => prev + 1);
      console.error("Error marking as read:", error);
    }
  };

  const markAllAsRead = async () => {
    setMarkingAll(true);
    try {
      await fetch(`${apiUrl}/NewNotification/MarkAllAsRead`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
      });
      setMessages(prev => prev.map(n => ({ ...n, isRead: true })));
      setUnreadMessages(0);
    } catch (error) {
      console.error("Error marking all as read:", error);
    } finally {
      setMarkingAll(false);
    }
  };

  const handleNotificationClick = (event) => {
    setNotifAnchor(event.currentTarget);
    setShowNotifDropdown(true);
    setNotifPageNo(1);
    notifPageNoRef.current = 1;
    fetchNotifications(1, false);
  };

  const handleCloseNotif = () => {
    setShowNotifDropdown(false);
    setNotifAnchor(null);
  };

  const getLinkStyle = (itemName) => ({
    color: activeItem === itemName.toLowerCase() ? "rgba(255,255,255,1)" : "rgba(200,220,255,0.9)",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    padding: "12px 20px",
    margin: "0 10px",
    borderRadius: "12px",
    backgroundColor: activeItem === itemName.toLowerCase() ? "rgba(255,255,255,0.1)" : "transparent",
    borderLeft: activeItem === itemName.toLowerCase() ? "4px solid rgba(69,150,164,1)" : "none",
    transition: "all 0.3s ease",
    fontWeight: activeItem === itemName.toLowerCase() ? "700" : "600",
    ...(hoveredItem === itemName && {
      backgroundColor: "rgba(255,255,255,0.05)",
      transform: "translateX(4px)",
      boxShadow: "0 2px 8px rgba(69,150,164,0.12)",
    }),
  });

  return (
    <div style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100%",
          width: "280px",
          background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
          boxShadow: "4px 0 16px rgba(69,150,164,0.12)",
          overflowY: "auto",
          zIndex: 1000,
          padding: "20px 0",
          color: "white",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "30px",
            color: "rgba(255,255,255,0.9)",
            fontSize: "1.5rem",
            fontWeight: "600",
          }}
        >
          {OrgName}
        </h2>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {/* Dashboard - Always visible and static */}
          <li style={{ marginBottom: "8px" }}>
            <Link
              to="/studentDashboard"
              style={getLinkStyle("Dashboard")}
              onClick={() => setActiveItem("dashboard")}
              onMouseEnter={() => setHoveredItem("Dashboard")}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div style={{ marginRight: "12px", fontSize: "1.2rem" }}>
                <FaTachometerAlt />
              </div>
              Dashboard
            </Link>
          </li>

          {/* Dynamic menu items from API */}
          {!loading && menuItems.map((item) => {
            const routeId = getRouteId(item.formName);
            const path = item.formUrl.replace("../../", "/");
            
            return (
              <li key={item.formId} style={{ marginBottom: "8px" }}>
                <Link
                  to={path}
                  style={getLinkStyle(item.formName)}
                  onClick={() => setActiveItem(routeId)}
                  onMouseEnter={() => setHoveredItem(item.formName)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <div style={{ marginRight: "12px", fontSize: "1.2rem" }}>
                    {getIconForForm(item.formName)}
                  </div>
                  {item.formName}
                </Link>
              </li>
            );
          })}

          {/* Logout button */}
          <li style={{ margin: "20px 10px 0" }}>
            <button
              onClick={() => setShowLogoutModal(true)}
              style={{
                color: "rgba(200,220,255,0.9)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                padding: "12px 20px",
                margin: "0 10px",
                borderRadius: "12px",
                width: "calc(100% - 20px)",
                textAlign: "left",
                transition: "all 0.3s ease",
                ...(hoveredItem === "Logout" && {
                  backgroundColor: "rgba(255,255,255,0.05)",
                  transform: "translateX(4px)",
                  boxShadow: "0 2px 8px rgba(69,150,164,0.12)",
                }),
              }}
              onMouseEnter={() => setHoveredItem("Logout")}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div style={{ marginRight: "12px", fontSize: "1.2rem" }}>
                <FaSignOutAlt />
              </div>
              Logout
            </button>
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div style={{ marginLeft: "280px", flex: 1, display: "flex", flexDirection: "column" }}>
        {/* Navbar */}
        <div
          style={{
            backgroundColor: "#fff",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
            padding: "15px 30px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 999,
            borderBottom: "1px solid #eee",
          }}
        >
          <div>
            <h1
              style={{
                color: "#2c3e50",
                margin: 0,
                fontSize: "1.6rem",
                fontWeight: "600",
                letterSpacing: "0.5px",
              }}
            >
              Welcome {studentName.replace(/['"]+/g, "")}!
            </h1>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
           <div style={{ position: "relative", marginRight: "25px" }}>
              <MuiTooltip title="Notifications" arrow>
                <span style={{ position: "relative", display: "inline-block" }}>
                  <FaBell
                    style={{
                      fontSize: "1.5rem",
                      cursor: "pointer",
                      color: "#555",
                      transition: "color 0.3s ease",
                    }}
                    onClick={handleNotificationClick}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#4596a4")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
                  />
                  {unreadMessages > 0 && (
                    <span style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      backgroundColor: "#ff4444",
                      color: "white",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.7rem",
                      boxShadow: "0 0 0 2px #fff",
                    }}>
                      {unreadMessages}
                    </span>
                  )}
                </span>
              </MuiTooltip>

              {/* Notification Dropdown */}
              <Popover
                open={showNotifDropdown}
                anchorEl={notifAnchor}
                onClose={handleCloseNotif}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                  sx: {
                    width: 400,
                    maxHeight: 500,
                    borderRadius: "16px",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
                    p: 0,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                  },
                }}
              >
                {/* Header */}
                <Box sx={{
                  px: 2.5, py: 1.8,
                  background: "linear-gradient(111.1deg, rgba(69,150,164,1) 2.5%, rgba(17,20,34,1) 100.3%)",
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  flexShrink: 0,
                }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <FaBell style={{ color: "#fff", fontSize: "1rem" }} />
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#fff", fontSize: "1rem" }}>
                      Notifications
                    </Typography>
                    {unreadMessages > 0 && (
                      <Chip label={unreadMessages} size="small"
                        sx={{ bgcolor: "#f44336", color: "#fff", fontWeight: 700, height: 20, fontSize: "0.7rem", ml: 0.5 }} />
                    )}
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {unreadMessages > 0 && (
                      <MuiTooltip title="Mark all as read">
                        <IconButton size="small" onClick={markAllAsRead} disabled={markingAll}
                          sx={{ color: "rgba(255,255,255,0.85)", "&:hover": { color: "#fff" } }}>
                          {markingAll
                            ? <CircularProgress size={14} sx={{ color: "#fff" }} />
                            : <DoneAllIcon fontSize="small" />}
                        </IconButton>
                      </MuiTooltip>
                    )}
                    <IconButton size="small" onClick={handleCloseNotif}
                      sx={{ color: "rgba(255,255,255,0.85)", "&:hover": { color: "#fff" } }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>

                {/* Scrollable list */}
                <Box
                  ref={notifListRef}
                  sx={{
                    flex: 1, overflowY: "auto", maxHeight: 370,
                    "&::-webkit-scrollbar": { width: 5 },
                    "&::-webkit-scrollbar-thumb": { background: "#9ecdd4", borderRadius: 3 },
                  }}
                  onScroll={async (e) => {
                    const el = e.currentTarget;
                    if (el.scrollHeight - el.scrollTop - el.clientHeight < 60 && hasMoreRef.current && !loadingMoreNotifs) {
                      setLoadingMoreNotifs(true);
                      const next = notifPageNoRef.current + 1;
                      notifPageNoRef.current = next;
                      setNotifPageNo(next);
                      await fetchNotifications(next, true);
                      setLoadingMoreNotifs(false);
                    }
                  }}
                >
                  {messages.length === 0 ? (
                    <Box sx={{ textAlign: "center", py: 6, px: 3 }}>
                      <FaBell style={{ fontSize: "3rem", color: "#e0e0e0", marginBottom: 8 }} />
                      <Typography variant="body2" color="text.secondary" fontWeight={600}>
                        You're all caught up!
                      </Typography>
                      <Typography variant="caption" color="text.disabled">
                        No notifications yet.
                      </Typography>
                    </Box>
                  ) : (
                    messages.map((notif, index) => {
                      const typeColors = { Reminder: "#ff9800", Success: "#4caf50", Alert: "#f44336", Info: "#2196f3" };
                      const dotColor = typeColors[notif.notificationType] || "#4596a4";
                      const initial = (notif.title || notif.name || "").charAt(0).toUpperCase() || "🔔";
                      return (
                        <Box
                          key={notif.recipientId}
                          onClick={() => { if (!notif.isRead) markAsRead(notif.recipientId); }}
                          sx={{
                            display: "flex", gap: 1.5, px: 2, py: 1.5,
                            cursor: notif.isRead ? "default" : "pointer",
                            bgcolor: !notif.isRead ? "rgba(69,150,164,0.06)" : "transparent",
                            borderLeft: !notif.isRead ? "3px solid rgba(69,150,164,0.6)" : "3px solid transparent",
                            borderBottom: index < messages.length - 1 ? "1px solid #f0f0f0" : "none",
                            transition: "background 0.15s",
                            "&:hover": { bgcolor: !notif.isRead ? "rgba(69,150,164,0.12)" : "rgba(0,0,0,0.03)" },
                          }}
                        >
                          <Box sx={{ position: "relative", flexShrink: 0 }}>
                            <Avatar sx={{
                              width: 38, height: 38, fontWeight: 700, fontSize: "0.95rem",
                              background: "linear-gradient(111.1deg, rgba(69,150,164,1) 2.5%, rgba(17,20,34,1) 100.3%)",
                            }}>
                              {initial}
                            </Avatar>
                            <Box sx={{
                              position: "absolute", bottom: 0, right: 0,
                              width: 10, height: 10, borderRadius: "50%",
                              bgcolor: dotColor, border: "2px solid #fff",
                            }} />
                          </Box>

                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                              <Typography variant="subtitle2"
                                fontWeight={notif.isRead ? 500 : 700}
                                color={notif.isRead ? "text.secondary" : "text.primary"}
                                sx={{ lineHeight: 1.3, flex: 1, pr: 1 }}
                                noWrap
                              >
                                {notif.title || notif.name}
                              </Typography>
                              <Typography variant="caption" color="text.disabled"
                                sx={{ whiteSpace: "nowrap", fontSize: "0.68rem", mt: 0.2 }}>
                                {notif.createdOn
                                  ? new Date(notif.createdOn).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
                                  : "Just now"}
                              </Typography>
                            </Box>

                            <Typography variant="body2" color="text.secondary"
                              sx={{ fontSize: "0.78rem", lineHeight: 1.4, mt: 0.3,
                                display: "-webkit-box", WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical", overflow: "hidden" }}
                            >
                              {notif.message}
                            </Typography>

                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 0.5 }}>
                              {notif.notificationType && (
                                <Chip label={notif.notificationType} size="small"
                                  sx={{ height: 16, fontSize: "0.62rem", fontWeight: 600,
                                    bgcolor: `${dotColor}18`, color: dotColor, px: 0.5 }} />
                              )}
                              {!notif.isRead && (
                                <MuiTooltip title="Mark as read">
                                  <IconButton size="small"
                                    onClick={e => { e.stopPropagation(); markAsRead(notif.recipientId); }}
                                    sx={{ color: "#4596a4", p: 0.5, ml: "auto", "&:hover": { bgcolor: "rgba(69,150,164,0.1)" } }}>
                                    <MarkEmailReadIcon sx={{ fontSize: "1rem" }} />
                                  </IconButton>
                                </MuiTooltip>
                              )}
                            </Box>
                          </Box>
                        </Box>
                      );
                    })
                  )}

                  {loadingMoreNotifs && (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                      <CircularProgress size={20} sx={{ color: "#4596a4" }} />
                    </Box>
                  )}
                </Box>

                {/* Footer */}
                {messages.length > 0 && (
                  <Box sx={{
                    borderTop: "1px solid #f0f0f0", px: 2, py: 1,
                    display: "flex", justifyContent: "center", bgcolor: "#fafafa", flexShrink: 0,
                  }}>
                    <Typography variant="caption"
                      sx={{ color: "#4596a4", cursor: "pointer", fontWeight: 600, fontSize: "0.78rem",
                        "&:hover": { textDecoration: "underline" } }}
                      onClick={() => { handleCloseNotif(); navigate("/student-notifications"); }}
                    >
                      View all notifications →
                    </Typography>
                  </Box>
                )}
              </Popover>
            </div> 
            <Tooltip title="View Profile" arrow>
              <span>
                <FaUserCircle
                  style={{
                    fontSize: "1.6rem",
                    marginRight: "20px",
                    color: "#555",
                    cursor: "pointer",
                    transition: "color 0.3s ease",
                  }}
                  onClick={handleProfileClick}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "#4596a4")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
                />
              </span>
            </Tooltip>
            <div style={{ position: "relative", marginRight: "15px" }}>
              <Tooltip title="Calendar" arrow>
                <span>
                  <FaCalendarAlt
                    style={{
                      fontSize: "1.5rem",
                      cursor: "pointer",
                      color: "#555",
                      transition: "color 0.3s ease",
                    }}
                    onClick={handleCalendarToggle}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#4596a4")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#555")}
                  />
                </span>
              </Tooltip>
              {showCalendar && (
                <div
                  style={{
                    position: "absolute",
                    top: "40px",
                    right: "0",
                    zIndex: 1000,
                    backgroundColor: "white",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                    borderRadius: "6px",
                    padding: "10px",
                  }}
                >
                  <Calendar />
                </div>
              )}
            </div>
            <div
              style={{
                marginLeft: "10px",
                color: "#666",
                fontSize: "0.9rem",
                backgroundColor: "#f8f9fa",
                padding: "5px 10px",
                borderRadius: "4px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
            >
              {currentDateTime.toLocaleDateString()} {currentDateTime.toLocaleTimeString()}
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div style={{ padding: "25px", flex: 1, overflowY: "auto", backgroundColor: "#f9fafb" }}>
          {content}
        </div>
      </div>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              maxWidth: "400px",
              width: "100%",
            }}
          >
            <h3 style={{ marginTop: 0, color: "#2c3e50" }}>Confirm Logout</h3>
            <p style={{ color: "#666", marginBottom: "20px" }}>
              Are you sure you want to logout?
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button
                onClick={() => setShowLogoutModal(false)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#f0f0f0",
                  color: "#333",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#4596a4",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Profile Modal */}
      {showProfileModal && <ProfileModal onClose={handleCloseProfileModal} />}
    </div>
  );
}

export default StudentsSidebar;